import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

// O Service Worker do Angular intercepta toda fetch/XHR da página, mesmo pra outra
// origem (a API) e mesmo sem nenhum dataGroup configurado pra ela em ngsw-config.json
// (só há assetGroups pra JS/CSS/imagens). O fetch que o próprio SW faz pra rede roda
// no escopo do worker, que sobrevive a reload/navegação da página — então, mesmo com
// a requisição original da página já cancelada (F5, troca de rota, busca superada),
// o fetch do SW continua pendente indefinidamente, e o backend nunca sabe que deve
// parar. `ngsw-bypass` é o mecanismo oficial do Angular pra pedir que o SW nem
// intercepte a requisição — o navegador cuida dela normalmente, com cancelamento
// funcionando como esperado.
@Injectable()
export class NgswBypassInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.startsWith(environment.apiUrl)) {
      const bypassedRequest = request.clone({
        setHeaders: { 'ngsw-bypass': 'true' },
      });
      return next.handle(bypassedRequest);
    }

    return next.handle(request);
  }
}
